import React from "react"
import PropTypes from "prop-types"
import "./styles.css"

const UpperCase = (str) => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}
const SelectedOption = ({ placeholder, value }) => (
  <div className={`selection active-selection`}>
    {!value ? placeholder : UpperCase(value)}
  </div>
)

SelectedOption.propTypes = {
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default SelectedOption
